"use client";

import { useState, useEffect } from "react";
import { getBankBrand } from "@/lib/bank-brands";

const PX = { sm: 20, md: 28 } as const;

export function BankIcon({
  bankName,
  size = "sm",
  className = "",
}: {
  bankName: string | undefined | null;
  size?: "sm" | "md";
  className?: string;
}) {
  const brand = getBankBrand(bankName);
  const px = PX[size];
  const [imgError, setImgError] = useState(false);

  // Reset error state when bankName changes so a new logo can load
  useEffect(() => {
    setImgError(false);
  }, [bankName]);

  // If we have a logo SVG and it hasn't errored, show the real logo
  if (brand?.logo && !imgError) {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        key={brand.logo}
        src={brand.logo}
        alt={bankName ?? "Bank"}
        title={bankName ?? undefined}
        width={px}
        height={px}
        className={`rounded-full object-cover shrink-0 ${className}`}
        style={{ width: px, height: px }}
        onError={() => setImgError(true)}
      />
    );
  }

  // Fallback: colored circle with abbreviation
  const abbr = brand?.abbr ?? (bankName ? bankName.charAt(0).toUpperCase() : "?");
  const bg = brand?.color ?? "#6B7280";
  const fg = brand?.textColor ?? "#FFFFFF";

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-bold shrink-0 ${className}`}
      style={{ backgroundColor: bg, color: fg, width: px, height: px, fontSize: px * 0.4 }}
      title={bankName ?? undefined}
    >
      {abbr}
    </span>
  );
}
